/**
 * 优惠券审核状态
 * @params string 优惠券审核状态(0待审核,1审核通过,2审核不通过)
 */
export default function couponAuditStatus(val) {
    let str = '';
    switch (val) {
    case 0:
        str = '待审核';
        break;
    case 1:
        str = '审核通过';
        break;
    case 2:
        str = '审核不通过';
        break;
    default:
        break;
    }
    return str;
}
